import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { handleTabKeyVisibleBtns, triggerExternalLinkPopup, isEqual } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { normalizeNavigationTitles } from '../../../generated/global-content/common/navigation-titles.js';
import { trackLinkClick } from '../../../common/metrics.js';
import img$2 from '../../../../assets/images/arrow-left.svg.js';
import img from '../../../../assets/images/arrow-right.svg.js';
import img$1 from '../../../../assets/images/cross-icon.svg.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import '../../atoms/buttons/icon-button/index.js';
import '../global-nav/index.js';
import { renderLeafPromo } from './helpers.js';
import css_248z from './main-nav-mobile.scss.js';
import './sub-nav.js';

class MainNavMobile extends s {
    constructor() {
        super(...arguments);
        this.backText = 'Back';
        this.forwardText = 'Forward';
        this.closeButtonText = '';
        this.goToHomePageText = 'Go to frontpage';
        this.rtl = false;
        this.open = false;
        this.submenuIsClosing = false;
        this.activeBranch = null;
        this.activeLeaf = null;
        this.activeViewDepth = 0;
        this.externalLinkPopup = null;
        this.rootMenu = null;
        this.branchContainer = null;
        this.leafContainer = null;
        this.renderLeafLinks = () => {
            var _a, _b, _c;
            return ((_b = (_a = this.activeLeaf) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length)
                ? (_c = this.activeLeaf) === null || _c === void 0 ? void 0 : _c.items.map(item => x `<a @click="${this.onLinkClick}" href="${item.link}">${item.title}</a>`)
                : null;
        };
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('data') && this.data) {
            this.data = this.data.map(branch => normalizeNavigationTitles(branch));
        }
        if (changedProperties.has('activeBranch') && this.activeBranch) {
            this.activeBranch = normalizeNavigationTitles(this.activeBranch);
        }
        if (changedProperties.has('activeLeaf') && this.activeLeaf) {
            this.activeLeaf = normalizeNavigationTitles(this.activeLeaf);
        }
    }
    focusTrap(container) {
        const input = document.createElement('input');
        input.setAttribute('aria-disabled', 'true');
        input.setAttribute('aria-hidden', 'true');
        container === null || container === void 0 ? void 0 : container.prepend(input);
        input.focus();
        input.blur();
        input.remove();
    }
    setRootFocus() {
        setTimeout(() => {
            if (this.rootMenu)
                this.focusTrap(this.rootMenu);
        }, 301);
    }
    setBranchFocus() {
        setTimeout(() => {
            if (this.branchContainer)
                this.focusTrap(this.branchContainer);
        }, 301);
    }
    setLeafFocus() {
        setTimeout(() => {
            if (this.leafContainer)
                this.focusTrap(this.leafContainer);
        }, 301);
    }
    setActiveBranch(branch) {
        this.activeViewDepth = 1;
        this.activeBranch = branch;
        this.setBranchFocus();
    }
    setActiveViewDepth(depth) {
        this.activeViewDepth = depth;
    }
    addKeydownListener() {
        const mainNav = this.shadowRoot.querySelector('.main-nav-mobile');
        let container;
        let additionalElements = [];
        const searchBar = document.querySelector('main-nav search-bar');
        const globalNav = document.querySelector('main-nav global-nav');
        switch (this.activeViewDepth) {
            case 1:
                container = this.branchContainer;
                break;
            case 2:
                container = this.leafContainer;
                break;
            default: {
                container = this.rootMenu;
                additionalElements = [];
                const searchBarBtns = searchBar === null || searchBar === void 0 ? void 0 : searchBar.shadowRoot.querySelectorAll('button');
                const globalNavLinks = globalNav === null || globalNav === void 0 ? void 0 : globalNav.querySelectorAll('a[slot="links"]');
                const globalNavBtns = globalNav === null || globalNav === void 0 ? void 0 : globalNav.shadowRoot.querySelectorAll('button, select');
                additionalElements = [
                    ...[...searchBarBtns],
                    ...[...globalNavLinks],
                    ...[...globalNavBtns],
                ];
                break;
            }
        }
        mainNav === null || mainNav === void 0 ? void 0 : mainNav.addEventListener('keydown', (e) => handleTabKeyVisibleBtns(e, container, 'a, button, icon-button', additionalElements));
    }
    updated(changedProperties) {
        if (changedProperties.has('open') &&
            this.open !== false &&
            this.open !== null) {
            this.setRootFocus();
        }
        this.addKeydownListener();
    }
    setActiveLeaf(leaf) {
        if (leaf.items.length === 0) {
            document.location.href = leaf.link;
            return;
        }
        this.activeViewDepth = 2;
        this.activeLeaf = leaf;
        this.setLeafFocus();
    }
    handleClose() {
        this.onClose();
        setTimeout(() => {
            this.activeViewDepth = 0;
            const mainNav = document.querySelector('main-nav');
            const mobileTrigger = mainNav === null || mainNav === void 0 ? void 0 : mainNav.shadowRoot.querySelector('.mobile-menu-trigger');
            mobileTrigger === null || mobileTrigger === void 0 ? void 0 : mobileTrigger.focus();
        }, 300);
    }
    onLinkClick(e) {
        trackLinkClick(e);
        triggerExternalLinkPopup(e, this);
    }
    renderMainMenu() {
        return this.data.map(branch => {
            const isActive = branch.active ? 'active' : null;
            return branch.items.length > 0
                ? x `<li><a class="main-nav-link ${isActive}" role="button" href="${branch.link}" @click="${(e) => {
                    e.preventDefault();
                    this.setActiveBranch(branch);
                }}">${branch.title}</a></li>`
                : x `<li><a class="main-nav-link ${isActive}" href="${branch.link}" @click="${this.onLinkClick}">${branch.title}</a></li>`;
        });
    }
    firstUpdated() {
        const modal = document.querySelector('cvt-modal[popupid="external-link"]');
        this.leafContainer = this.shadowRoot.querySelector('.leaf-container');
        this.branchContainer = this.shadowRoot.querySelector('.branch-container');
        this.rootMenu = this.shadowRoot.querySelector('.root-menu');
        if (!modal)
            return;
        this.externalLinkPopup = modal.querySelector('external-link');
    }
    renderBranch() {
        return this.activeBranch
            ? this.activeBranch.items.map(leaf => {
                var _a;
                if (((_a = leaf.items) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    return x `<a href="${l(leaf.link)}" class="branch branch-mobile ${o({
                        active: isEqual(leaf, this.activeLeaf),
                    })}" @click="${this.onLinkClick}"><img loading="lazy" class="branch-img ${o({ hidden: !leaf.img })}" src="${l(leaf.img)}" alt="submenu link"><div class="content"><p class="title">${leaf.title}</p><p class="description">${leaf.description}</p><img slot="icon" .src="${img}" alt="" aria-hidden="true"></div></a>`;
                }
                return x `<a class="branch branch-mobile ${o({
                    active: isEqual(leaf, this.activeLeaf),
                })}" role="button" href="${l(leaf.link)}" @click="${(e) => {
                    e.preventDefault();
                    this.setActiveLeaf(leaf);
                }}"><img loading="lazy" class="branch-img ${o({ hidden: !leaf.img })}" src="${l(leaf.img)}" alt="" aria-hidden="true"><div class="content"><p class="title">${leaf.title}</p><p class="description">${leaf.description}</p><img slot="icon" .src="${img}" alt="" aria-hidden="true"></div></a>`;
            })
            : null;
    }
    renderBranchHeading() {
        return this.activeBranch
            ? x `<a class="root-page-link" href="${this.activeBranch.link}" @click="${this.onLinkClick}">${this.activeBranch.headlineTitle}</a>`
            : null;
    }
    renderLeaf() {
        return this.activeLeaf
            ? x `<div class="leaf leaf-mobile"><div class="leaf-links"><a class="primary-link" @click="${this.onLinkClick}" href="${l(this.activeLeaf.link)}">${this.activeLeaf.title} </a>${this.renderLeafLinks()}</div>${renderLeafPromo(this.activeLeaf.promo)}</div>`
            : null;
    }
    render() {
        const containerClassMap = {
            rtl: this.rtl || isRTL(),
            container: true,
            [`depth-${this.activeViewDepth}`]: true,
        };
        return x `<div class="main-nav-mobile"><div class="${o(containerClassMap)}"><div class="root-menu"><div class="header"><a href="/" aria-label="${this.goToHomePageText}"><slot name="logo-mobile"></slot></a><icon-button type="button" styletype="${ButtonStyleTypes.LIGHT}" ariaLabel="${this.closeButtonText}" @click="${this.handleClose}"><img slot="icon" .src="${img$1}" alt="" aria-hidden="true"></icon-button></div><ul class="root-menu-links">${this.renderMainMenu()}</ul><div class="root-menu-bottom"><div class="nav-bottom-cta"><slot name="button"></slot></div><slot name="global-nav"></slot></div></div><div class="branch-container"><div class="header"><button class="button-back" @click="${() => {
            this.setActiveViewDepth(0);
            this.setRootFocus();
        }}" aria-label="${this.backText}"><img loading="lazy" .src="${img$2}" alt="" aria-hidden="true"> <span>${this.backText}</span></button><icon-button type="button" styletype="${ButtonStyleTypes.LIGHT}" @click="${this.handleClose}" ariaLabel="${this.backText}"><img slot="icon" .src="${img$1}" alt="" aria-hidden="true"></icon-button></div><ul class="branch-links">${this.renderBranchHeading()} ${this.renderBranch()}</ul></div><div class="leaf-container"><div class="header"><button class="button-back" @click="${() => {
            this.setActiveViewDepth(1);
            this.setBranchFocus();
        }}" aria-label="${this.backText}"><img loading="lazy" .src="${img$2}" alt="" aria-hidden="true"> <span>${this.backText}</span></button><icon-button type="button" styletype="${ButtonStyleTypes.LIGHT}" @click="${this.handleClose}" ariaLabel="${this.closeButtonText}"><img slot="icon" .src="${img$1}" alt="" aria-hidden="true"></icon-button></div>${this.renderLeaf()}</div></div></div>`;
    }
}
MainNavMobile.styles = css_248z;
__decorate([
    n({ type: Object })
], MainNavMobile.prototype, "data", void 0);
__decorate([
    n()
], MainNavMobile.prototype, "backText", void 0);
__decorate([
    n()
], MainNavMobile.prototype, "forwardText", void 0);
__decorate([
    n()
], MainNavMobile.prototype, "closeButtonText", void 0);
__decorate([
    n()
], MainNavMobile.prototype, "goToHomePageText", void 0);
__decorate([
    n({ type: Function })
], MainNavMobile.prototype, "onClose", void 0);
__decorate([
    n({ type: Boolean })
], MainNavMobile.prototype, "rtl", void 0);
__decorate([
    n()
], MainNavMobile.prototype, "open", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "submenuIsClosing", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "activeBranch", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "activeLeaf", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "activeViewDepth", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "externalLinkPopup", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "rootMenu", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "branchContainer", void 0);
__decorate([
    t()
], MainNavMobile.prototype, "leafContainer", void 0);
customElements.define('main-nav-mobile', MainNavMobile);

export { MainNavMobile };
